module.exports = __webpack_public_path__ + "static/resume.c015ffef.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/resume.pdf
// module id = ./src/data/resume.pdf
// module chunks = 189066279150898